const getters = {
  token: (state) => state.login.token,
  showLoading: (state) => state.login.showLoading,
  personalData: (state) => state.personal.personalData
};
export default getters;
